import { gql } from 'graphql-request'

export const QueryBlockFeatureSimple = gql`
  fragment FragmentBlockFeatureSimple on BlockFeatureSimpleModelRecord {
          __typename
          id
          preface
          title
          background
          simpleContentBlocks {
            ...FragmentSimpleBlock
          }
          featureCardBlocks {
            ...FragmentFeatureCardBlock
          }
          anchor
        }
`
export const BlockFeatureSimple = {
  __typename: 'BlockFeatureSimple',
  fragmentName: 'FragmentBlockFeatureSimple',
  fragmentQuery: QueryBlockFeatureSimple,
  fragments: [
    'FragmentNavigationItem',
    'FragmentFeatureCardBlock',
    'FragmentSimpleBlock',
    'FragmentFormattedTextBlock'
  ]
}
